/* ==========================================================================
   ZARPINA — scripts propios. Vanilla, sin librerias externas.
   Una funcion init por componente. Cada una sale sola si su elemento
   no esta en la pagina, asi el mismo archivo sirve para toda la tienda.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Utilidad: avisa a los pixeles sin acoplarnos a ellos --------------
     Los pixeles reales (Meta / TikTok) se enganchan en la fase de medicion.
     Aqui solo emitimos el evento; si no hay nadie escuchando, no pasa nada. */
  function emitir(nombre, datos) {
    try {
      document.dispatchEvent(new CustomEvent('zp:' + nombre, { detail: datos || {} }));
    } catch (e) { /* navegador muy antiguo: ignorar */ }
  }

  /* ======================================================================
     Galeria de producto
     ====================================================================== */
  function initGaleria() {
    var galeria = document.querySelector('[data-zp-galeria]');
    if (!galeria) return;

    var principal = galeria.querySelector('[data-zp-galeria-principal]');
    var miniaturas = galeria.querySelectorAll('[data-zp-miniatura]');
    if (!principal || !miniaturas.length) return;

    miniaturas.forEach(function (boton) {
      boton.addEventListener('click', function () {
        var src = boton.getAttribute('data-src');
        var srcset = boton.getAttribute('data-srcset');
        var alt = boton.getAttribute('data-alt') || '';
        if (!src) return;

        principal.src = src;
        if (srcset) principal.srcset = srcset;
        principal.alt = alt;

        miniaturas.forEach(function (m) { m.setAttribute('aria-current', 'false'); });
        boton.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ======================================================================
     Selector de packs  ->  variantes reales de Shopify
     ====================================================================== */
  function initPacks() {
    var raiz = document.querySelector('[data-zp-producto]');
    if (!raiz) return;

    var json = raiz.querySelector('[data-zp-variantes]');
    var inputId = raiz.querySelector('[data-zp-variant-id]');
    if (!json || !inputId) return;

    var variantes;
    try { variantes = JSON.parse(json.textContent); } catch (e) { return; }
    if (!variantes || !variantes.length) return;

    var radios = raiz.querySelectorAll('[data-zp-pack]');
    var botonesColor = raiz.querySelectorAll('[data-zp-color]');
    var etiquetaColor = raiz.querySelector('[data-zp-color-elegido]');
    var botones = document.querySelectorAll('[data-zp-boton-compra]');
    var precioCta = document.querySelectorAll('[data-zp-precio-cta]');
    var stickyPrecio = document.querySelector('[data-zp-sticky-precio]');
    var stickyPack = document.querySelector('[data-zp-sticky-pack]');

    var colorActual = '';
    var elegido = raiz.querySelector('[data-zp-color][aria-checked="true"]');
    if (elegido) colorActual = elegido.getAttribute('data-zp-color');

    function packSeleccionado() {
      var r = raiz.querySelector('[data-zp-pack]:checked');
      return r ? r.value : (radios[0] ? radios[0].value : '');
    }

    function buscar(pack, color) {
      for (var i = 0; i < variantes.length; i++) {
        if (variantes[i].pack === pack && (!color || variantes[i].color === color)) {
          return variantes[i];
        }
      }
      return null;
    }

    /* Cada tarjeta de pack muestra el importe del COLOR elegido. */
    function pintarTarjetas() {
      radios.forEach(function (r) {
        var d = buscar(r.value, colorActual);
        var caja = r.closest('.zp-pack');
        if (!caja) return;
        var total = caja.querySelector('[data-zp-pack-total]');
        var unidad = caja.querySelector('[data-zp-pack-unidad]');
        var ahorro = caja.querySelector('[data-zp-pack-ahorro]');
        if (!d) {
          if (total) total.textContent = '';
          if (unidad) unidad.textContent = 'No disponible';
          if (ahorro) ahorro.textContent = '';
          r.disabled = true;
          caja.setAttribute('data-agotado', 'true');
          return;
        }
        r.disabled = !d.disponible;
        caja.setAttribute('data-agotado', d.disponible ? 'false' : 'true');
        if (total) total.textContent = d.precio;
        if (unidad) unidad.textContent = d.disponible ? (d.precioUnidad ? d.precioUnidad + ' por unidad' : '') : 'Agotado';
        if (ahorro) ahorro.textContent = d.ahorro ? 'Ahorras ' + d.ahorro : '';
      });
    }

    function aplicar(esInicial) {
      var d = buscar(packSeleccionado(), colorActual);
      if (!d) return;

      inputId.value = d.id;

      var textoCompra = raiz.getAttribute('data-texto-compra') || 'Lo quiero';
      var textoAgotado = raiz.getAttribute('data-texto-agotado') || 'Agotado';
      var nombre = d.pack + (d.color ? ' · ' + d.color : '');

      precioCta.forEach(function (e) { e.textContent = d.precio; });
      if (stickyPrecio) stickyPrecio.textContent = d.precio;
      if (stickyPack) stickyPack.textContent = nombre;
      if (etiquetaColor) etiquetaColor.textContent = colorActual;

      botones.forEach(function (b) {
        b.disabled = !d.disponible;
        var etiqueta = b.querySelector('[data-zp-boton-texto]');
        if (etiqueta) etiqueta.textContent = d.disponible ? textoCompra : textoAgotado;
      });

      if (!esInicial) emitir('pack-cambiado', { id: d.id, nombre: nombre });
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) aplicar(false); });
    });

    botonesColor.forEach(function (b) {
      b.addEventListener('click', function () {
        colorActual = b.getAttribute('data-zp-color');
        botonesColor.forEach(function (o) {
          o.setAttribute('aria-checked', o === b ? 'true' : 'false');
        });
        pintarTarjetas();
        aplicar(false);
      });
    });

    pintarTarjetas();
    aplicar(true);
  }

  /* ======================================================================
     Barra sticky de movil: aparece cuando el CTA principal sale de pantalla
     ====================================================================== */
  function initSticky() {
    var barra = document.querySelector('[data-zp-sticky]');
    var ctaPrincipal = document.querySelector('[data-zp-cta-principal]');
    var galeria = document.querySelector('[data-zp-galeria]');
    if (!barra) return;

    document.body.classList.add('zp-con-sticky');

    if (!('IntersectionObserver' in window)) {
      barra.setAttribute('data-visible', 'true');
      return;
    }

    /* En movil el boton principal cae por debajo del pliegue: no cabe todo
       en una pantalla. Para que nunca haya un momento sin CTA a la vista,
       la barra aparece en cuanto se pasa la galeria, y se esconde mientras
       el boton principal esta en pantalla (para no tener dos CTA a la vez). */
    var pasadaGaleria = false;
    var ctaALaVista = false;

    function pintar() {
      barra.setAttribute('data-visible', (pasadaGaleria && !ctaALaVista) ? 'true' : 'false');
    }

    if (galeria) {
      new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          pasadaGaleria = !e.isIntersecting && e.boundingClientRect.top < 0;
          pintar();
        });
      }, { threshold: 0 }).observe(galeria);
    } else {
      pasadaGaleria = true;
    }

    if (ctaPrincipal) {
      new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          ctaALaVista = e.isIntersecting;
          pintar();
        });
      }, { threshold: 0 }).observe(ctaPrincipal);
    }

    pintar();
  }

  /* ======================================================================
     Acordeon de preguntas frecuentes
     ====================================================================== */
  function initFaq() {
    var items = document.querySelectorAll('[data-zp-faq-item]');
    if (!items.length) return;

    items.forEach(function (item) {
      var boton = item.querySelector('[data-zp-faq-boton]');
      var panel = item.querySelector('[data-zp-faq-panel]');
      if (!boton || !panel) return;

      boton.addEventListener('click', function () {
        var abierto = boton.getAttribute('aria-expanded') === 'true';
        boton.setAttribute('aria-expanded', abierto ? 'false' : 'true');
        panel.setAttribute('data-abierto', abierto ? 'false' : 'true');
        if (!abierto) emitir('faq-abierta', { pregunta: boton.textContent.trim() });
      });
    });
  }

  /* ======================================================================
     Animaciones de entrada al hacer scroll
     ====================================================================== */
  function initReveal() {
    var elementos = document.querySelectorAll('.zp-reveal');
    if (!elementos.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) { el.classList.add('zp-visible'); });
      return;
    }

    var observador = new IntersectionObserver(function (entradas, obs) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('zp-visible');
        obs.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    elementos.forEach(function (el) { observador.observe(el); });
  }

  /* ======================================================================
     Video de demostracion: solo carga y reproduce cuando entra en pantalla
     (ahorra datos y no penaliza el LCP)
     ====================================================================== */
  function initDemo() {
    var video = document.querySelector('[data-zp-demo-video]');
    if (!video) return;

    if (!('IntersectionObserver' in window)) { video.play().catch(function () {}); return; }

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) {
          video.play().catch(function () {});   // iOS bloquea si no es muted+playsinline
          emitir('demo-vista', {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.4 });

    observador.observe(video);
  }

  /* ======================================================================
     Compra: alta en el carrito sin recargar la pagina + eventos de medicion
     ====================================================================== */
  function initCompra() {
    var raiz = document.querySelector('[data-zp-producto]');
    var form = document.querySelector('form.zp-form-compra, [data-zp-form-compra]');
    if (!raiz || !form) return;

    var enCurso = false;

    function datosPack() {
      var radio = document.querySelector('[data-zp-pack]:checked');
      var idInput = form.querySelector('[data-zp-variant-id]');
      return {
        variantId: radio ? radio.value : (idInput ? idInput.value : null),
        nombre: radio ? radio.getAttribute('data-nombre') : null,
        valor: radio ? radio.getAttribute('data-precio-centimos')
                     : raiz.getAttribute('data-producto-precio')
      };
    }

    function abrirCajon(respuesta) {
      // Dawn expone <cart-drawer>. Si esta, lo abrimos; si no, vamos a /cart.
      var cajon = document.querySelector('cart-drawer');
      if (cajon && typeof cajon.renderContents === 'function') {
        try { cajon.renderContents(respuesta); return true; } catch (e) { /* sigue abajo */ }
      }
      if (cajon && typeof cajon.open === 'function') {
        try { cajon.open(); return true; } catch (e) { /* sigue abajo */ }
      }
      return false;
    }

    function anadir() {
      if (enCurso) return;
      enCurso = true;

      var botones = document.querySelectorAll('[data-zp-boton-compra]');
      botones.forEach(function (b) { b.disabled = true; });

      var cuerpo = new FormData(form);
      // Pedimos de paso el HTML del cajon para que Dawn lo pinte al vuelo
      var cajon = document.querySelector('cart-drawer');
      if (cajon && typeof cajon.getSectionsToRender === 'function') {
        try {
          cuerpo.append('sections', cajon.getSectionsToRender().map(function (s) { return s.id; }));
          cuerpo.append('sections_url', window.location.pathname);
        } catch (e) { /* seguimos sin secciones */ }
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: cuerpo
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.json.description || 'error');
          emitir('add-to-cart', datosPack());
          if (!abrirCajon(res.json)) window.location.href = '/cart';
        })
        .catch(function () {
          // Plan B: envio clasico del formulario, que siempre funciona
          form.submit();
        })
        .finally(function () {
          enCurso = false;
          botones.forEach(function (b) {
            var radio = document.querySelector('[data-zp-pack]:checked');
            b.disabled = radio ? radio.getAttribute('data-disponible') !== 'true' : false;
          });
        });
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      anadir();
    });

    var botonSticky = document.querySelector('[data-zp-sticky-boton]');
    if (botonSticky) botonSticky.addEventListener('click', anadir);

    emitir('view-content', {
      productId: raiz.getAttribute('data-producto-id'),
      valor: raiz.getAttribute('data-producto-precio')
    });
  }

  /* ======================================================================
     Upsell del carrito: anade sin sacar al cliente del cajon
     Se delega en document porque el cajon se repinta entero al cambiar.
     ====================================================================== */
  function initUpsell() {
    if (window.__zpUpsellListo) return;
    window.__zpUpsellListo = true;

    document.addEventListener('click', function (ev) {
      var boton = ev.target.closest && ev.target.closest('[data-zp-upsell-anadir]');
      if (!boton || boton.disabled) return;

      var variante = boton.getAttribute('data-variante');
      if (!variante) return;

      var etiqueta = boton.querySelector('[data-zp-upsell-texto]');
      var textoOriginal = etiqueta ? etiqueta.textContent : '';
      boton.disabled = true;
      if (etiqueta) etiqueta.textContent = 'Añadiendo…';

      var cuerpo = new FormData();
      cuerpo.append('id', variante);
      cuerpo.append('quantity', 1);

      var cajon = document.querySelector('cart-drawer');
      if (cajon && typeof cajon.getSectionsToRender === 'function') {
        try {
          cuerpo.append('sections', cajon.getSectionsToRender().map(function (s) { return s.id; }));
          cuerpo.append('sections_url', window.location.pathname);
        } catch (e) { /* seguimos sin secciones */ }
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: cuerpo
      })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          emitir('upsell-anadido', { variantId: variante });
          if (cajon && typeof cajon.renderContents === 'function') {
            cajon.renderContents(json);   // repinta el cajon, el upsell desaparece solo
          } else {
            window.location.reload();
          }
        })
        .catch(function () {
          boton.disabled = false;
          if (etiqueta) etiqueta.textContent = textoOriginal;
        });
    });
  }

  /* --- Arranque ---------------------------------------------------------- */
  function arrancar() {
    initUpsell();
    initGaleria();
    initPacks();
    initSticky();
    initFaq();
    initReveal();
    initDemo();
    initCompra();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
